var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenReshareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.2439C15.8579 21.2439 12.5 18.0001 12.5 13.9986C12.5 11.4691 13.8418 9.24241 15.8754 7.94646M21.1363 6.836C24.7392 7.36498 27.5 10.3703 27.5 13.9986C27.5 16.6088 26.0712 18.8966 23.928 20.1719M20.9379 8.6744L18.9492 6.75322L20.9379 4.83203V8.6744ZM18.9484 19.323L20.9371 21.2442L18.9484 23.1654L18.9484 19.323Z",
    stroke: "#50C878",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenReshareIcon);
export default __webpack_public_path__ + "static/media/Green_ReshareIcon.1cb328fd4a7807e1a2d8438087c70c5a.svg";
export { ForwardRef as ReactComponent };